<!-- 商品管理-商品库 -->

<template>
  <div class="main" v-loading="loading">
    <!-- 顶部搜索 -->
    <div class="s_wrapper">
      <el-cascader :options="cascaderOptions" placeholder="选择商品类目(二级)" v-model="categoryIds" @change="onSearch"
        :props="cascaderprops" collapse-tags clearable></el-cascader>
      <el-input class="s_input" placeholder="搜索商品名称" suffix-icon="el-icon-search" v-model="productName"
        :clearable="true" @change="onSearch"></el-input>
      <el-input class="s_input" placeholder="搜索商品条形码" suffix-icon="el-icon-search" v-model="barCode" :clearable="true"
        @change="onSearch"></el-input>
      <el-select v-model="productType" placeholder="选择商品类型" @change="onSearch" clearable>
        <el-option v-for="item in productTypeOption" :key="item.value" :label="item.label"
          :value="item.value"></el-option>
      </el-select>
      <!-- <el-button class="btn" type="primary" @click="batchChangeStatus('down')"
        :disabled="multipleSelection.length == 0">批量下架</el-button>
      <el-button class="btn" type="primary" @click="batchChangeStatus('up')"
        :disabled="multipleSelection.length == 0">批量上架</el-button> -->
    </div>

    <!-- 表格 -->
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540" @selection-change="handleSelectionChange"
        ref="tableRef" row-key="id">
        <!-- <el-table-column type="selection" min-width="55"></el-table-column> -->
        <el-table-column label="序号" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column label="图片" width="110">
          <template slot-scope="scope">
            <span class="show_img" @click="previewImage(scope.row.picList)">查看图片</span>
          </template>
        </el-table-column>
        <el-table-column prop="brand" label="品牌" show-overflow-tooltip min-width="100"></el-table-column>
        <el-table-column prop="barCode" label="商品条形码" show-overflow-tooltip min-width="160"></el-table-column>
        <el-table-column prop="productName" label="商品名称" show-overflow-tooltip min-width="150"></el-table-column>
        <el-table-column prop="productType" label="商品类型" show-overflow-tooltip min-width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.productType == 1">免费领</span>
            <span v-if="scope.row.productType == 2">优惠品</span>
            <span v-if="scope.row.productType == 3">热销品</span>
          </template>
        </el-table-column>
        <el-table-column prop="specs" label="规格" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column prop="categoryName" label="分类" show-overflow-tooltip min-width="100"></el-table-column>
        <el-table-column prop="factoryName" label="厂家" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column prop="validityPeriod" label="保质期(天)" show-overflow-tooltip min-width="100"></el-table-column>
        <el-table-column prop="inventoryCount" label="总库存" show-overflow-tooltip min-width="100"></el-table-column>
        <!-- <el-table-column label="上下架状态" header-align="center" align="center" min-width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.switch" active-color="#1777d9" inactive-color="#E2E2E2"
              @change="changeStatus(scope.row)"></el-switch>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" header-align="center" align="center" min-width="180" fixed="right">
          <template slot-scope="scope">
            <el-button size="small" class="btn" type="primary" plain @click="handleCheck(scope.row)">查看</el-button>
            <el-button size="small" class="btn" type="primary" plain @click="handleOpen(scope.row)">增加库存数</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <el-image-viewer v-if="showViewer" :on-close="() => {
      showViewer = false
    }
      " :url-list="imgList"></el-image-viewer>

    <!-- 增加商品库存弹窗 -->
    <el-dialog title="增加商品库存" :visible.sync="dialogVisible" @close="handleCloseDialog">
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" class="demo-ruleForm" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="供应商名称" prop="supplierName">
              <el-input v-model="ruleForm.supplierName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="进货价（元）" prop="buyPrice">
              <el-input v-model="ruleForm.buyPrice" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="增加库存数" prop="increaseQuantity">
              <el-input v-model="ruleForm.increaseQuantity" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="生产日期" prop="date">
              <el-date-picker v-model="ruleForm.date" type="date" placeholder="选择生产日期"
                :picker-options="expireTimeOption">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" plain @click="handleCloseDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      expireTimeOption: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      loading: false,
      productId: null, // 点击增加库存当行productId
      productType: '', // 选择商品类型
      productTypeOption: [{
        label: '免费领',
        value: 1
      },
      {
        label: '优惠品',
        value: 2
      },
      {
        label: '热销品',
        value: 3
      },
      ], // 商品类型下拉框
      categoryIds: "", // 搜索分类
      cascaderOptions: [],
      productName: "", // 搜索商品名称
      barCode: "", // 搜索商品条形码
      // 弹窗
      dialogVisible: false,
      officeId: "",
      dialogTitle: "",
      ruleForm: {
        supplierName: "",
        buyPrice: "",
        increaseQuantity: "",
        date: "",
      },
      rules: {
        supplierName: [{
          required: true,
          message: "请输入供应商名称",
          trigger: "blur",
        },],
        buyPrice: [{
          required: true,
          message: "请输入进货价",
          trigger: "blur",
        }, {
          validator: (rule, value, callback) => {
            if (value && !/^\d+(\.\d+)?$/.test(value)) {
              callback(new Error("只能输入数字或小数"));
            } else {
              callback();
            }
          },
          trigger: "blur",
        }],
        increaseQuantity: [{
          required: true,
          message: "请输入增加库存数",
          trigger: "blur",
        },
        {
          validator: (rule, value, callback) => {
            if (value && !/^\d+$/.test(value)) {
              callback(new Error("只能输入数字"))
            } else {
              callback()
            }
          },
          trigger: "blur",
        },
        ],
        date: [{
          required: true,
          message: "请选择生产日期",
          trigger: "blur",
        },],
      },
      // 表格数据
      tableData: [],
      multipleSelection: [],
      cascaderprops: {
        checkStrictly: false,
        emitPath: false,
        multiple: true,
        value: "categoryId",
        label: "categoryName",
        children: "children",
      },
      // 图片预览
      showViewer: false,
      imgList: [],
      // 分页
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.selectProductList()
    this.getCategoryList()
  },
  methods: {
    // 列表
    selectProductList() {
      this.loading = true
      this.$axios
        .post(this.$api.selectProductList, {
          categoryIdList: this.categoryIds.length == 0 ? null : this.categoryIds,
          productName: this.productName || null,
          barCode: this.barCode || null,
          sellStatus: this.shelfStatus || null,
          page: this.currentPage,
          pageSize: this.pageSize,
          storeId: this.$store.state.userInfo.bizId,
        })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list.map(e => {
              return {
                ...e,
                switch: e.sellStatus == 1 ? true : false
              }
            }) || []
            this.totalItemsCount = res.result.totalCount
            this.loading = false
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    getCategoryList() {
      this.$axios
        .get(this.$api.getCategoryInfoList, {
          params: {
            page: 1,
            pageSize: 9999,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.cascaderOptions = res.result.list
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 选中
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 切换上下架
    // changeStatus(row) {
    //   const originalSwitch = row.switch
    //   this.$confirm(`确定${row.switch ? "上架" : "下架"}该商品吗？`, "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //     center: true,
    //   })
    //     .then(() => {
    //       this.$axios
    //         .post(this.$api.changeMallStatus, {
    //           productIdList: [row.productId],
    //           saleStatus: row.switch ? 1 : 0,
    //           storeId: this.$store.state.userInfo.bizId,
    //         })
    //         .then(() => {
    //           this.$set(row, "switch", originalSwitch)
    //           this.$message.success("操作成功")
    //           this.selectProductList()
    //         })
    //         .catch(() => {
    //           this.$set(row, "switch", !originalSwitch)
    //           this.selectProductList()
    //         })
    //     })
    //     .catch(() => {
    //       this.$set(row, "switch", !originalSwitch)
    //       this.selectProductList()
    //     })
    // },
    // 批量切换上下架状态
    // batchChangeStatus(status) {
    //   const action = status === "up" ? "上架" : "下架"
    //   const ids = this.multipleSelection.map(item => item.productId)

    //   this.$confirm(`确定批量${action}这些商品吗？`, "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //     center: true,
    //   })
    //     .then(() => {
    //       this.$axios
    //         .post(this.$api.changeMallStatus, {
    //           productIdList: ids,
    //           saleStatus: status === "up" ? 1 : 0,
    //           storeId: this.$store.state.userInfo.bizId,
    //         })
    //         .then(() => {
    //           // 批量操作成功后更新商品列表状态
    //           this.multipleSelection.forEach(item => {
    //             item.switch = status === "up" ? true : false
    //           })
    //           this.$message.success(`批量${action}操作成功`)
    //           this.selectProductList()
    //         })
    //         .catch(() => {
    //           this.selectProductList()
    //         })
    //     })
    //     .catch(() => {
    //       // 取消操作时恢复之前的选择状态
    //       this.multipleSelection.forEach(item => {
    //         item.switch = !item.switch
    //       })
    //       this.selectProductList()
    //     })
    // },
    // 增加库存
    handleOpen(row) {
      this.dialogVisible = true
      this.productId = row.productId
    },
    // 关闭弹窗
    handleCloseDialog() {
      this.dialogVisible = false
      this.resetForm()
      this.ruleForm = {}
      this.productId = null
    },
    // 表单校验
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          console.log("error submit!!")
          return false
        }
        this.$axios
          .post(this.$api.updateStoreInventory, {
            supplierName: this.ruleForm.supplierName,
            inventoryCount: this.ruleForm.increaseQuantity,
            supplyPrice: this.ruleForm.buyPrice,
            produceDate: this.ruleForm.date,
            productId: this.productId,
            storeId: this.$store.state.userInfo.bizId,
            sourceType: 2,
          })
          .then(res => {
            if (res.code === 100) {
              this.$message.success(res.desc)
              this.handleCloseDialog()
              this.selectProductList()
            }
          })
          .catch(err => {
            this.$message.error(err.desc)
          })
      })
    },

    // 默认弹窗设置重置表单
    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
    // 跳转
    handleCheck(row) {
      this.$router.push({
        path: "/product/detail/info",
        query: {
          productId: row.productId
        }
      })
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 搜索
    onSearch() {
      this.clearData()
      this.selectProductList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.clearData()
      this.pageSize = e
      this.selectProductList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.selectProductList()
    },
    // 图片预览
    previewImage(url) {
      this.imgList = url || []
      this.showViewer = true
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  .el-cascader {
    width: 230px;
    margin-right: 20px;
  }

  .busilicense {
    display: block;
    width: 80px;
    height: 58px;
    border-radius: 4px;
  }

  .show_img {
    color: #1777d8;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }
}
</style>
